//  ----------      START   IMPORT  BLOCK       ----------
import { useState, useEffect } from 'react';
//  Widgets
import { Card } from 'react-bootstrap';
import FilterDropdown from './FilterDropdown';
//  Config
import './FloatingCard.css';
import { VocabDentistry } from '../../../ConfigFiles/multilingual/VocabDentistry';
//  ----------      END   IMPORT  BLOCK       ----------

const FloatingCard = ({ show, lan }) => {
  const [selectedTeeth, setSelectedTeeth] = useState(['all']); // Selected tooth filter
  const [data, setData] = useState([]); // Full patient history data
  const [filteredData, setFilteredData] = useState([]); // Filtered data to display

  const toothOptions = [
    'all',
    '11', '12', '13', '14', '15', '16', '17', '18',
    '21', '22', '23', '24', '25', '26', '27', '28',
    '31', '32', '33', '34', '35', '36', '37', '38',
    '41', '42', '43', '44', '45', '46', '47', '48',
  ];

  useEffect(() => {
    try {
      const patientHistory = JSON.parse(localStorage.getItem('patient_history_odonto')) || null;
      const entries = patientHistory?.odontogram_entries || [];
      setData(entries);
      setFilteredData(entries);
    } catch (error) {
      console.error('Error parsing patient history data:', error);
      setData([]);
      setFilteredData([]);
    }
  }, []);

  useEffect(() => {
    if (selectedTeeth.includes('all')) {
      setFilteredData(data);
    } else if (data) {
      const filtered = data
        .map((entry) => {
          const filteredTeethNotes = entry.teeth_notes.filter((tooth) =>
            selectedTeeth.includes(tooth.id.toString())
          );
          if (filteredTeethNotes.length > 0) {
            return { ...entry, teeth_notes: filteredTeethNotes };
          }
          return null;
        })
        .filter(Boolean);
      setFilteredData(filtered);
    }
  }, [selectedTeeth, data]);

  const groupByToothAndSection = () => {
    const grouped = {};
    if (!filteredData || filteredData.length === 0) return grouped;

    filteredData.forEach((entry) => {
      entry.teeth_notes.forEach((tooth) => {
        if (!grouped[tooth.id]) {
          grouped[tooth.id] = {};
        }
        ['root', 'mesial', 'distal', 'vestibular', 'palatine', 'labial'].forEach((section) => {
          if (tooth[section]) {
            if (!grouped[tooth.id][section]) {
              grouped[tooth.id][section] = [];
            }
            grouped[tooth.id][section].push({
              description: tooth[section].description,
              date: entry.created_on,
            });
          }
        });
      });
    });

    return grouped;
  };

  const groupedData = groupByToothAndSection();

  if (!show) return null;

  return (
    <div className="floating-card">
      <Card>
        <Card.Body className="card-body">
          <Card.Title>{VocabDentistry.odontogram_history[lan]}</Card.Title>
          {data === null || data.length === 0 ? (
            <p>{VocabDentistry.no_data[lan]}</p>
          ) : (
            <>
              <FilterDropdown
                selectedTeeth={selectedTeeth}
                setSelectedTeeth={setSelectedTeeth}
                lan={lan}
                toothOptions={toothOptions}
              />

              {/* General Notes */}
              {selectedTeeth.includes('all') && (
                <div className="general-notes">
                  <h5>{VocabDentistry.general_note[lan]}</h5>
                  {filteredData.map((entry, index) => (
                    <p
                      key={index}
                      className="general-note-text"
                      title={new Date(entry.created_on).toLocaleDateString()}
                    >
                      {entry.general_note}
                    </p>
                  ))}
                </div>
              )}

              {/* Grouped Tooth/Section Data */}
              {Object.keys(groupedData).length > 0 ? (
                Object.entries(groupedData).map(([toothId, sections]) => (
                  <div key={toothId} className="odontogram-tooth">
                    <h5>
                      {VocabDentistry.tooth[lan]} {toothId}
                    </h5>
                    <ul>
                      {Object.entries(sections).map(([section, entries]) => (
                        <li key={section}>
                          <strong>{VocabDentistry[section][lan]}:</strong>
                          <ul>
                            {entries.map((entry, index) => (
                              <li
                                key={index}
                                title={new Date(entry.date).toLocaleDateString()}
                              >
                                {entry.description}
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                    <hr />
                  </div>
                ))
              ) : (
                <p>{VocabDentistry.no_data[lan]}</p>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default FloatingCard;
